import axios from "axios";
import { host } from "../config";
import { signOut } from "./auth-action";

const AUTH_FAILURE_MESSAGES = [
  "authentication failed",
  "please log in again",
  "please login again",
  "unauthorized",
  "status code: 401",
];

const isAuthFailure = (errorOrData) => {
  const status =
    errorOrData?.response?.status ??
    errorOrData?.status ??
    errorOrData?.code ??
    errorOrData?.response?.data?.code ??
    errorOrData?.response?.data?.status ??
    errorOrData?.response?.data?.status_code ??
    errorOrData?.status_code;

  if (Number(status) === 401) {
    return true;
  }

  const message = String(
    errorOrData?.response?.data?.message ??
      errorOrData?.message ??
      errorOrData?.error ??
      errorOrData
  ).toLowerCase();

  return AUTH_FAILURE_MESSAGES.some((authMessage) =>
    message.includes(authMessage)
  );
};

const handleAuthFailure = (errorOrData, dispatch) => {
  if (!isAuthFailure(errorOrData)) {
    return false;
  }

  dispatch(signOut());
  return true;
};

const get = async (url, params, dispatch, getState) => {
  const token = getState().auth.token;
  return new Promise((resolve, reject) => {
    axios
      .get(host + url, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (handleAuthFailure(res?.data, dispatch)) {
          return;
        }
        resolve(res);
      })
      .catch((err) => {
        if (handleAuthFailure(err, dispatch)) {
          return;
        }
        reject(String(err));
      });
  });
};

const post = (url, body, dispatch, getState,image) => {
  
  //: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
 
  const token = getState().auth.token;
  const headers= image?{ Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }:{ Authorization: `Bearer ${token}` }
  return new Promise((resolve, reject) => {
    axios
      .post(host + url, body, {
        headers: headers
      })
      .then((res) => {
        if (handleAuthFailure(res?.data, dispatch)) {
          return;
        }
        resolve(res);
      })
      .catch((err) => {
        if (handleAuthFailure(err, dispatch)) {
          return;
        }
        reject(String(err));
      });
  });
};
const postJson = (url, body, dispatch, getState,image) => {
  
  //: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
 
  const token = getState().auth.token;
  const headers= { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
  return new Promise((resolve, reject) => {
    axios
      .post(host + url, body, {
        headers: headers
      })
      .then((res) => {
        if (handleAuthFailure(res?.data, dispatch)) {
          return;
        }
        resolve(res);
      })
      .catch((err) => {
        if (handleAuthFailure(err, dispatch)) {
          return;
        }
        reject(String(err));
      });
  });
};
const Delete = (url, body, dispatch, getState) => {
  const token = getState().auth.token;
  return new Promise((resolve, reject) => {
    axios
      (
        {
          url:host + url,
          data:body,
          method:'delete',
          headers: {
            Authorization: `Bearer ${token}`
          },
        }
      )
      .then((res) => {
        if (handleAuthFailure(res?.data, dispatch)) {
          return;
        }
        resolve(res);
      })
      .catch((err) => {
        if (handleAuthFailure(err, dispatch)) {
          return;
        }
        reject(String(err));
      });
  });
};

export default {
  get: get,
  post: post,
  delete: Delete,
  postJson: postJson,
};
